import { useContext } from 'react';

import type { MessagingContextValue } from 'src/contexts/MessagingContext';
import MessagingContext from 'src/contexts/MessagingContext';

const useMessaging = (): MessagingContextValue => useContext(MessagingContext);

export default useMessaging;
